export default "__VITE_ASSET__CAcf7nZV__"